import { inject, NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { AuthGuard, DashboardGuard, AdminGuard } from './_shared';
import { AffiliateGuard } from './_shared/guards/affiliate/affiliate.guard';
import { SymbolInfoResolve } from './_shared/resolvers/trading.component.resolver';
import { AuthService } from './modules/auth';


const routes: Routes = [
    { path: '', redirectTo: 'trading', pathMatch: 'full' },
    {
        path: 'auth/logout',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule), // this is a dummy route to handle the logout request
        canActivate: [() => {
            const authService = inject(AuthService);
            const router = inject(Router);
            authService.logoutApi();
            router.navigate(['/auth/login']);
            return false;
        }],
    },
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
        canActivate: [AuthGuard],
        canLoad: [AuthGuard]
    },
    {
        path: 'trading',
        loadChildren: () => import('./modules/trading/trading.module').then(m => m.TradingModule),
        canActivate: [DashboardGuard],
        canLoad: [DashboardGuard],
        resolve: {
            info: SymbolInfoResolve
        }
    },
    {
        path: 'admin',
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
        canActivate: [AdminGuard],
        canLoad: [AdminGuard]
    },
    {
        path: 'affiliate',
        loadChildren: () => import('./modules/affiliate/affiliate.module').then(m => m.AffiliateModule),
        canActivate: [AffiliateGuard],
        canLoad: [AffiliateGuard]
    },
    {
        path: 'policies',
        loadChildren: () => import('./modules/info-pages/info-pages.module').then(m => m.InfoPagesModule),
    },
    {
        path: 'chart',
        loadChildren: () => import('./modules/trading/modules/fullscreen-chart/fullscreen-chart.module').then(m => m.FullscreenChartModule),
    },
    // {
    //     path: 'plans-mobile',
    //     loadChildren: () => import('./modules/trading/modules/mb-plans-mobile/mb-plans-mobile.module').then(m => m.MbPlansMobileModule),
    // },
    { path: '**', redirectTo: 'trading', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
